import type * as oauth from "oauth4webapi";
import { defineStore } from "pinia";

interface User {
	name?: string;
	email?: string;
	picture?: string;
}

interface AuthState {
	user: User | null;
}

export const useAuthStore = defineStore("auth", {
	state: (): AuthState => ({
		user: null,
	}),
	actions: {
		setUser(claim?: oauth.IDToken) {
			if (!claim) {
				this.user = null;
				return;
			}
			this.user = {
				name: claim.name,
				email: claim.email,
				picture: claim.string,
			} as User;
		},
		clearAuthUser() {
			this.user = null;
		},
	},
});
